module.exports = __webpack_public_path__ + "static/media/covi_wel_que_man.be095cab.png";